import { CheckboxOption } from '@common/components/CheckboxOption/CheckboxOption';
import { getNewSubmissionReasons, getUpdateSubmissionReasons } from '@common/features/reasons/submissionReasons';
import * as Styled from './styles';
import { ContentDetailsFormField } from '../../pages/ContentDetails/types';
import { useFormContext } from 'react-hook-form';
import { useFormSelectedItems } from '@common/hooks/useFormSelectedItems';
import { DocumentType } from '@common/types';
import { StyledLink } from '@common/components/Link/styles';
import { richTextEditorContentValidator } from '@common/helpers';
import { HookFormRichTextEditor} from '@common/components';

interface ISubmissionDetails {
  contentType: DocumentType;
  version: number;
}

export const SubmissionDetails = ({ contentType, version }: ISubmissionDetails) => {
  const { toggleItem, isItemSelected } = useFormSelectedItems(ContentDetailsFormField.reasonsForSubmission);
  const toolbarOptions = [[{ header: [1, 2, 3, 4, false] }], ['bold', 'italic', 'underline'], [{ list: 'ordered' }, { list: 'bullet' }], ['link']];


  
  const {
    formState: { errors },
  } = useFormContext();

  const renderDetails = () => {
    var reasons = version === 1 ? getNewSubmissionReasons(contentType) : getUpdateSubmissionReasons(contentType);

    return reasons.map((item, index) => {
      const isSelected = isItemSelected(item);
      return (
        <CheckboxOption
          data-testid={`reason-checkbox-${index}`}
          key={item.id}
          name={`submission detail ${item.id}`}
          item={item}
          onChange={toggleItem}
          isChecked={isSelected}
        />
      );
    });
  };

  var showChangeDetails = version > 1;

  return (
    <Styled.SubmissionDetailsWrap>
      <Styled.SubmissionReasonsWrap>
        <Styled.SectionLabel>Reasons for submission</Styled.SectionLabel>
        <Styled.SubmissionReasonsContent>{renderDetails()}</Styled.SubmissionReasonsContent>
      </Styled.SubmissionReasonsWrap>
      {showChangeDetails && (
        <>
          <Styled.SubmissionChangeDetails>
            <Styled.SubmissionChangeDetailsHeading>{`${contentType} change details`}</Styled.SubmissionChangeDetailsHeading>
            <Styled.SubmissionChangeDetailsText>
              Please add the details of what has been changed below, this information is published on the website exactly as you
              enter it.
            </Styled.SubmissionChangeDetailsText>
            <Styled.SubmissionChangeDetailsText>
              We recommend not adding a contact telephone number or copying the whole {contentType} without explanation. For more
              information click{' '}
              <StyledLink to={process.env.REACT_APP_HELP_URL ?? ''} target="_blank">
                here &gt;
              </StyledLink>
            </Styled.SubmissionChangeDetailsText>
            <Styled.SubmissionNotesContent>
              <HookFormRichTextEditor
                formField={ContentDetailsFormField.details}
                name="Submission notes"
                toolbarOptions={toolbarOptions}
                className="addModalEditorWrapper"
                placeholder="Notes here (eg. Section 1 update)"
                rules={{
                  validate: (value: string) => richTextEditorContentValidator(value, 6000),
                }}
              />
            </Styled.SubmissionNotesContent>
          </Styled.SubmissionChangeDetails>
        </>
      )}
    </Styled.SubmissionDetailsWrap>
  );
};
